import React, { useEffect, useState } from "react";
import { PlusOutlined, DeleteOutlined, CloseOutlined, CheckOutlined, EditOutlined, PlusSquareFilled, ExpandAltOutlined } from '@ant-design/icons';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import { Modal, Col, Row, Table, Button, Form, FormInstance, Select, Input, Checkbox, DatePicker, Space, Spin } from 'antd';
import dayjs from 'dayjs';
import { AlignType } from 'rc-table/lib/interface';
import { isValidCNPJ } from 'cnpj-cpf-validator';
import { errorMessage, mostrarInfo } from "../../../utils/messages";
import { disabledDate } from "../../../utils/utilsFunctions";
import { IExperienciaPessoaFisica } from "./InterfacePessoaFisica";
import { onlyNumbers } from "../../../utils/utilsFunctions";
import { maskCnpj } from "../../../utils/maskFunctions";
import { consultarCnpj } from "../../../services/apiExternos";
import { hasPermissao, Papel } from "../../../auth/entidadeUsuario";
import { IAreaConhecimento, IOcupacaoPrincipal } from "../../../Interfaces/Interfaces";
import { lista_enumNivel, lista_tipoVinculo } from "../../../config/Contantes";


interface IProps {
  form: FormInstance<any>;
  experiencias: IExperienciaPessoaFisica[];
  setExperiencias: React.Dispatch<React.SetStateAction<IExperienciaPessoaFisica[]>>;
  manter?: number; // 1 : Inserir / 2 : Consultar / 3 : Editar / 9 :  Histórico;
  areas: IAreaConhecimento[];
  ocupacoes: IOcupacaoPrincipal[];
}

const { Option } = Select;
const { TextArea } = Input;

const PessoaFisicaExperiencia = ({ form, experiencias, setExperiencias, manter, areas, ocupacoes }: IProps) => {
  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");

  const [estadoModal, setEstadoModal] = useState(1); // 1 : Modal em modo inserção / 2 : Modal em modo detalhe /  3 : Modal em modo edição
  const [exibirModalEx, setExibirModalEx] = useState(false);
  const [exibirExperienciaCadastrada, setExibirExperienciaCadastrada] = useState("none");
  const [exibirElementoAcaoAlteracao, setExibirElementoAcaoAlteracao] = useState("inline");
  const [dadosValidados, setDadosValidados] = useState(false);

  const [isDtFimDisabled, setIsDtFimDisabled] = useState(false);
  const [isDefaultChecked, setIsDefaultChecked] = useState(false);
  const [dadosReceitaCnpjAsString, setDadosReceitaCnpjAsString] = useState("");


  useEffect(() => {
    if (experiencias && experiencias.length === 0) {
      setExibirExperienciaCadastrada("none")
    } else {
      setExibirExperienciaCadastrada("inline")
      setValoresAuxiliares();
    }
  }, [experiencias]);

  useEffect(() => {
    if (manter === 2 || manter === 9) { // Detalhar / Histórico
      setExibirElementoAcaoAlteracao("none");
    } else {
      setExibirElementoAcaoAlteracao("inline");
    }
  }, [manter]);

  useEffect(() => {
    if (estadoModal === 3) { // EM EDIÇÃO
      controleDaGrid("editar"); // CONFIGURA MODAL PARA ABRIR
      setIsDefaultChecked(form?.getFieldValue("boTrabalhoAtual"));
      setIsDtFimDisabled(form?.getFieldValue("boTrabalhoAtual"));
    } else if (estadoModal === 2) { // EXIBIR DETALHES
      controleDaGrid("detalhar"); // CONFIGURA MODAL PARA ABRIR
      setIsDefaultChecked(form?.getFieldValue("boTrabalhoAtual"));
      setIsDtFimDisabled(form?.getFieldValue("boTrabalhoAtual"));
    } else { // EM INSERÇÃO
      setIsDefaultChecked(false);
      setIsDtFimDisabled(false);
    }
  }, [estadoModal])


  const controleDaGrid = (botao: string) => {
    if (form.getFieldValue("nuCpf") === "") {
      mostrarInfo("Não é possível incluir nova experiência profissional", "CPF ainda não informado");
    } else {
      if (botao === "cancelar") {
        setExibirModalEx(false);
        setExibirElementoAcaoAlteracao("inline");
      } else if (botao === "incluir") {
        setExibirModalEx(false);
        setExibirElementoAcaoAlteracao("inline");
      } else {
        setExibirModalEx(true);
        setExibirElementoAcaoAlteracao("none");
      }
    }

    if (manter === 2 || manter === 9) { // Detalhar / Histórico
      setExibirElementoAcaoAlteracao("none");
    }
  };

  const validarExperiencia = () => {
    // console.log(form?.getFieldValue("boTrabalhoAtual"));
    const boTrabalhoAtual = form.getFieldValue("boTrabalhoAtual");
    const endDatetime = form.getFieldValue("dtFim");

    if (boTrabalhoAtual && endDatetime) {
      errorMessage("Data de fim indevida para experiência atual");
    } else if (((boTrabalhoAtual && !boTrabalhoAtual) || !boTrabalhoAtual) && (!endDatetime)) {
      errorMessage(
        "Data de fim obrigatória para experiências anteriores"
      );
    } else if (Number(form.getFieldValue("nuAnoConclusao")) < 1950 || Number(form.getFieldValue("nuAnoConclusao")) > new Date().getFullYear()) {
      errorMessage("Informe um ano de conclusão válido");
    } else if (Number(form.getFieldValue("nuCargaHoraria")) < 1) {
      errorMessage("Informe uma carga horária válida");
    } else {
      form
        .validateFields([
          "nomeAreaConhecimento",
          "idAreaConhecimento",
          "idOcupacaoPrincipal",
          "nomeOcupacaoPrincipal",
          "dtInicio",
          "dtFim",
          "csNivel",
          "nivel",
          "csTpVinculo",
          "tipoVinculo",
          "nuCnpj",
          // "nmFantasia",
          "nmRazaoSocial",
          "teDescricao",
          "boTrabalhoAtual",
          "ativo",
        ])
        .then(() => {
          setDadosValidados(true);
          controleDaGrid("incluir");
          setDadosExperiencia();
          // successMessage(estadoModal === 3 ? "Experiencia Profissional Alterada" : "Experiencia Profissional Adicionada");

        })
        .catch((error) => {
          if (!dadosValidados) {
            errorMessage("Campo obrigatório não preechido ou não validado");
          } else {
            errorMessage(error.message);
          }
          setDadosValidados(false);
        });
    }
  };

  function setDadosExperiencia() {
    if (estadoModal === 3) { // ESTADO EDIÇÃO DE REGISTROS
      setExperiencias(pre => {
        return pre.map(exp => {
          if (exp.emEdicao) {
            return ({
              idPessoaFisicaExperienciaProfissional: estadoModal === 3 ? Number(form?.getFieldValue("idPessoaFisicaExperienciaProfissional")) : -1,
              idAreaConhecimento: Number(form?.getFieldValue("idAreaConhecimento")),
              idOcupacaoPrincipal: Number(form?.getFieldValue("idOcupacaoPrincipal")),
              nomeOcupacaoPrincipal: form?.getFieldValue("nomeOcupacaoPrincipal")?.toUpperCase(),
              nomeAreaConhecimento: form?.getFieldValue("nomeAreaConhecimento")?.toUpperCase(),
              dtInicio: form?.getFieldValue("dtInicio") ? dayjs(form?.getFieldValue("dtInicio")).format("YYYY-MM-DD") : "",
              dtFim: form?.getFieldValue("dtFim") ? dayjs(form?.getFieldValue("dtFim")).format("YYYY-MM-DD") : "",
              csNivel: Number(form?.getFieldValue("csNivel")),
              nivel: form?.getFieldValue("nivel")?.toUpperCase(),
              csTpVinculo: Number(form?.getFieldValue("csTpVinculo")),
              tipoVinculo: form?.getFieldValue("tipoVinculo")?.toUpperCase(),
              nuCnpj: onlyNumbers(form?.getFieldValue("nuCnpj")),
              // nmFantasia: form?.getFieldValue("nmFantasia")?.toUpperCase(),
              nmRazaoSocial: form?.getFieldValue("nmRazaoSocial")?.toUpperCase(),
              teDescricao: form?.getFieldValue("teDescricao")?.toUpperCase(),
              boTrabalhoAtual: form?.getFieldValue("boTrabalhoAtual"),
              statusReg: 1,
              touched: true,
              emEdicao: false,
              dadosReceita: dadosReceitaCnpjAsString,
            })
          } else {
            return exp
          }
        })
      });
    } else {
      setExperiencias([
        ...experiencias,
        {
          idPessoaFisicaExperienciaProfissional: estadoModal === 3 ? Number(form?.getFieldValue("idPessoaFisicaExperienciaProfissional")) : -1,
          idAreaConhecimento: Number(form?.getFieldValue("idAreaConhecimento")),
          idOcupacaoPrincipal: Number(form?.getFieldValue("idOcupacaoPrincipal")),
          nomeOcupacaoPrincipal: form?.getFieldValue("nomeOcupacaoPrincipal")?.toUpperCase(),
          nomeAreaConhecimento: form?.getFieldValue("nomeAreaConhecimento")?.toUpperCase(),
          dtInicio: form?.getFieldValue("dtInicio") ? dayjs(form?.getFieldValue("dtInicio")).format("YYYY-MM-DD") : "",
          dtFim: form?.getFieldValue("dtFim") ? dayjs(form?.getFieldValue("dtFim")).format("YYYY-MM-DD") : "",
          csNivel: Number(form?.getFieldValue("csNivel")),
          nivel: form?.getFieldValue("nivel")?.toUpperCase(),
          csTpVinculo: Number(form?.getFieldValue("csTpVinculo")),
          tipoVinculo: form?.getFieldValue("tipoVinculo")?.toUpperCase(),
          nuCnpj: onlyNumbers(form?.getFieldValue("nuCnpj")),
          // nmFantasia: form?.getFieldValue("nmFantasia")?.toUpperCase(),
          nmRazaoSocial: form?.getFieldValue("nmRazaoSocial")?.toUpperCase(),
          teDescricao: form?.getFieldValue("teDescricao")?.toUpperCase(),
          boTrabalhoAtual: form?.getFieldValue("boTrabalhoAtual"),
          statusReg: 1,
          emEdicao: false,
          dadosReceita: dadosReceitaCnpjAsString,
          touched: true,
        },
      ]);
    }
    form.resetFields([
      "idPessoaFisicaExperienciaProfissional",
      "nomeAreaConhecimento",
      "idAreaConhecimento",
      "idOcupacaoPrincipal",
      "nomeOcupacaoPrincipal",
      "dtInicio",
      "dtFim",
      "csNivel",
      "nivel",
      "csTpVinculo",
      "tipoVinculo",
      "nuCnpj",
      // "nmFantasia",
      "nmRazaoSocial",
      "teDescricao",
      "boTrabalhoAtual",
      "ativo",
    ]);
    setDadosReceitaCnpjAsString("");
    setEstadoModal(1); // SETA O MODAL PARA INCLUSÃO (MODO PADRÃO).
  }

  const setFieldsDetalharEditar = (IExperiencia: IExperienciaPessoaFisica) => {
    form.setFieldsValue({
      "idPessoaFisicaExperienciaProfissional": IExperiencia.idPessoaFisicaExperienciaProfissional,
      "idAreaConhecimento": IExperiencia.areaConhecimento && IExperiencia.areaConhecimento.idAreaConhecimento ? IExperiencia.areaConhecimento.idAreaConhecimento : IExperiencia.idAreaConhecimento,
      "idOcupacaoPrincipal": IExperiencia.ocupacaoPrincipal && IExperiencia.ocupacaoPrincipal.idOcupacao ? IExperiencia.ocupacaoPrincipal.idOcupacao : IExperiencia.idOcupacaoPrincipal,
      "nomeOcupacaoPrincipal": IExperiencia.ocupacaoPrincipal && IExperiencia.ocupacaoPrincipal.nuCodigo ? IExperiencia.ocupacaoPrincipal.nuCodigo + " - " + IExperiencia.ocupacaoPrincipal.teTitulo : IExperiencia.nomeOcupacaoPrincipal,
      "nomeAreaConhecimento": IExperiencia.areaConhecimento && IExperiencia.areaConhecimento.nmArea ? IExperiencia.areaConhecimento.nmArea : IExperiencia.nomeAreaConhecimento,
      "dtInicio": IExperiencia.dtInicio ? dayjs(IExperiencia.dtInicio) : undefined,
      "dtFim": IExperiencia.dtFim ? dayjs(IExperiencia.dtFim) : undefined,
      "csNivel": IExperiencia.csNivel,
      "nivel": IExperiencia.nivel,
      "csTpVinculo": IExperiencia.csTpVinculo,
      "tipoVinculo": IExperiencia.tipoVinculo,
      "nuCnpj": maskCnpj(IExperiencia.nuCnpj),
      // "nmFantasia": IExperiencia.nmFantasia,
      "nmRazaoSocial": IExperiencia.nmRazaoSocial,
      "teDescricao": IExperiencia.teDescricao,
      "boTrabalhoAtual": IExperiencia.boTrabalhoAtual ? IExperiencia.boTrabalhoAtual : false,
    });
  }

  const setValoresAuxiliares = (() => {

    experiencias.forEach(experiencia => {
      lista_tipoVinculo.forEach(e => {
        if (experiencia.csTpVinculo === e.enum) {
          experiencia.tipoVinculo = e.tipoVinculo
        }
      })

      lista_enumNivel.forEach(e => {
        if (experiencia.csNivel === e.enum) {
          experiencia.nivel = e.nivel
        }
      })
    })
  })

  async function getCnpj(cnpj: string) {
    if (cnpj) {
      setTipLoading("Buscando dados do CNPJ ...");
      setLoading(true);

      await consultarCnpj(cnpj).then((response) => {
        if (!response.data) {
          errorMessage(
            "Não foi possível coletar informações sobre o CNPJ informado. Verifique se o CNPJ está correto."
          );
        } else {
          setDadosReceitaCnpjAsString(JSON.stringify(response.data)); // TRANSFORMA DTO EM STRING.
          form.setFieldsValue({
            "nmRazaoSocial": response.data?.nomeEmpresarial ? response.data?.nomeEmpresarial.toUpperCase() : undefined,
            // nmFantasia: response.data?.nomeFantasia ? response.data?.nomeFantasia.toUpperCase() : undefined,
          });
        }
        setLoading(false);
      })
        .catch((error) => {
          setLoading(false);
          mostrarInfo("Erro de acesso à API de CNPJ", "Não foi possível acessar a API de localização de CNPJ. Tente novamente mais tarde, por favor. Se o erro persisiter, entre em contato com o suporte (" + error.message + ").");
        })
    }
  }


  const handlerOcupacaoPrincipal = async (value: any) => {
    form.setFieldsValue({
      "nomeOcupacaoPrincipal": value.children,
      "idOcupacaoPrincipal": value.key,
    });
  };

  const handlerTpVinculo = async (value: any) => {
    form.setFieldsValue({
      "tipoVinculo": value.children,
      "csTpVinculo": value.key,
    });
  };

  const handlerNivel = async (value: any) => {
    form.setFieldsValue({
      "nivel": value.children,
      "csNivel": value.key,
    });
  };

  const handlerBoTrabalhoAtual = (e: CheckboxChangeEvent) => {
    setIsDtFimDisabled(e.target.checked);
    form.setFieldsValue({
      "boTrabalhoAtual": e.target.checked,
    });

    if (e.target.checked) {
      form.resetFields([
        "dtFim",
      ]);
    }
  };

  const handlerArea = async (value: any) => {
    form.setFieldsValue({
      nomeAreaConhecimento: value.children,
      idAreaConhecimento: value.key,
    });
  };

  const maskcnpjChange = async (isValue: any) => {
    isValue = maskCnpj(isValue);
    form.setFieldsValue({
      nuCnpj: isValue,
    });
  };

  // Executado ao sair do campo CNPJ
  const handleNuCnpjInputBlur = (nuCnpj: string) => {
    if (isValidCNPJ(nuCnpj)) {
      nuCnpj = nuCnpj.replace(/\D/g, ""); //Remove tudo o que não é dígito
      getCnpj(nuCnpj);
    }
  };

  const columns = [
    {
      // width: 200,
      key: "1",
      title: "Cargo/Função",
      dataIndex: "",
      render: (IExperiencia: IExperienciaPessoaFisica) => <>{IExperiencia.ocupacaoPrincipal && IExperiencia.ocupacaoPrincipal.nuCodigo ? (IExperiencia.ocupacaoPrincipal.nuCodigo + " - " + IExperiencia.ocupacaoPrincipal.teTitulo).toUpperCase() : IExperiencia.nomeOcupacaoPrincipal?.toUpperCase()}</>,
    },
    {
      // width: 200,
      key: "2",
      title: "Data Início",
      dataIndex: "",
      render: (IExperiencia: IExperienciaPessoaFisica) => <>{dayjs(IExperiencia.dtInicio).format("DD/MM/YYYY")}</>,
    },
    {
      // width: 200,
      key: "3",
      title: "Data Fim",
      dataIndex: "",
      render: (IExperiencia: IExperienciaPessoaFisica) => <>{IExperiencia.boTrabalhoAtual ? " ATÉ O MOMENTO" : dayjs(IExperiencia.dtFim).format("DD/MM/YYYY")}</>,
    },
    {
      key: "9",
      title: "Opções",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (IExperiencia: IExperienciaPessoaFisica) => (
          <Space style={{justifyContent: 'center'}}>
            <div style={{ display: manter === 2 || manter === 9 ? "inline" : "none" }}>
              <ExpandAltOutlined
                title="Detalhar"
                style={{ color: "blue", marginLeft: 12 }}
                onClick={() => {
                  setEstadoModal(2); // SET O MODO DETALHAR
                  setFieldsDetalharEditar(IExperiencia);
                }}
              />
            </div>

            <div style={{ display: manter === 1 ? "inline" : exibirElementoAcaoAlteracao }}>
              <EditOutlined
                title="Editar"
                style={{ color: "blue", marginLeft: 12 }}
                onClick={() => {
                  setEstadoModal(3); // SET O MODO EDIÇÃO
                  setFieldsDetalharEditar(IExperiencia);
                  // ALTERA CAMPOS DO DATASET PARA REFLETIR O ESTADO DE EDIÇÃO
                  experiencias.forEach(exp => {
                    if (exp === IExperiencia) {
                      exp.statusReg = 1;
                      exp.touched = true;
                      exp.emEdicao = estadoModal === 3 ? true : false;
                    } else {
                      exp.emEdicao = false;
                    }
                  })
                  IExperiencia.emEdicao = true;
                }}
              />

              <DeleteOutlined
                title="Exluir"
                style={{ color: "red", display: (IExperiencia?.idPessoaFisicaExperienciaProfissional && IExperiencia?.idPessoaFisicaExperienciaProfissional < 0) ? "inline" : "none" }} // EXCLUSÃO DE REGISTRO SENDO INSERIDO NO PROCESSO DE ALTERAÇÃO. OU SEJA. QUE AINDA NÃO ESTÁ NA BASE
                onClick={() => {
                  setExperiencias(experiencias.filter((experiencia) => experiencia !== IExperiencia));
                }}
              />
            </div>

            <div style={{ display: (IExperiencia?.idPessoaFisicaExperienciaProfissional && IExperiencia?.idPessoaFisicaExperienciaProfissional > 0) && hasPermissao([Papel.DILIC_MASTER]) ? exibirElementoAcaoAlteracao : "none" }}>
              <>
                <PlusSquareFilled
                  title="Desmarcar para exclução/inativação"
                  style={{ color: "blue", display: (IExperiencia?.statusReg === 1 || IExperiencia?.statusReg === undefined) ? "none" : "inline" }}
                  onClick={() => {
                    IExperiencia.touched = true; // MARCA O REGISTRO ALTERADO.
                    IExperiencia.statusReg = (IExperiencia.statusReg === 1 ? 2 : 1);
                    setExperiencias(pre => { //TROCA O REGISTRO DO DATASET PELO REGISTRO EM ALTERAÇÃO
                      return pre.map(experiencia => {
                        if (experiencia.idPessoaFisicaExperienciaProfissional === IExperiencia.idPessoaFisicaExperienciaProfissional) {
                          return IExperiencia;
                        } else {
                          return experiencia;
                        }
                      });
                    });
                  }}
                />
                <DeleteOutlined
                  title="Marcar para exclução/inativação"
                  style={{ color: "red", display: (IExperiencia?.statusReg === 1 || IExperiencia?.statusReg === undefined) ? "inline" : "none" }}
                  onClick={() => {
                    IExperiencia.touched = true; // MARCA O REGISTRO ALTERADO.
                    IExperiencia.statusReg = (IExperiencia.statusReg === 1 ? 2 : 1);
                    setExperiencias(pre => {
                      return pre.map(experiencia => {
                        if (experiencia.idPessoaFisicaExperienciaProfissional === IExperiencia.idPessoaFisicaExperienciaProfissional) {
                          return IExperiencia;
                        } else {
                          return experiencia;
                        }
                      });
                    });
                  }}
                />
              </>
            </div>
          </Space>
      ),
    },

  ];

  const handleCancel = () => {
    setEstadoModal(1); // COLOCA O MODAL EM ESTADO DE INCLUSÃO DE NOVO REGISTRO. MODO PADRÃO
    controleDaGrid("cancelar");
    form.resetFields([
      "idPessoaFisicaExperienciaProfissional",
      "nomeAreaConhecimento",
      "idAreaConhecimento",
      "idOcupacaoPrincipal",
      "nomeOcupacaoPrincipal",
      "dtInicio",
      "dtFim",
      "csNivel",
      "nivel",
      "csTpVinculo",
      "tipoVinculo",
      "nuCnpj",
      // "nmFantasia",
      "nmRazaoSocial",
      "teDescricao",
      "boTrabalhoAtual",
      "ativo",
    ]);
  };

  return (
    <>
      <Button
        style={{ display: exibirElementoAcaoAlteracao }}
        id="incluirExperiencia"
        type="primary"
        shape="round"
        onClick={() => {
          setEstadoModal(1); // COLOCA O MODAL EM ESTADO DE INCLUSÃO DE NOVO REGISTRO.
          controleDaGrid("incluirExperiencia");
        }}
        icon={<PlusOutlined />}
      >
        Incluir Experiencia
      </Button>

      <>
        <Modal title="Experiência Profissional" open={exibirModalEx}
          style={{ top: 20 }}
          destroyOnHidden={true}
          width={700}
          closable={false}
          footer={[
            <Button icon={<CloseOutlined />} shape="round" key="cancelFechar" onClick={handleCancel}>
              {estadoModal === 2 ? "Fechar" : "Cancelar"}
            </Button>,
            <Button icon={<CheckOutlined />} shape="round" style={{ display: estadoModal === 2 ? "none" : "inline" }}
              key="ok" type="primary" onClick={validarExperiencia}>
              {estadoModal === 3 ? "Alterar" : "Incluir"}
            </Button>,
          ]}
        >
          <Spin spinning={loading} tip={tipLoading}>

            <Row>
              <Col xs={24} xl={12}>
                <Form.Item
                  name="boTrabalhoAtual"
                  colon={false}
                >
                  <Checkbox
                    onChange={handlerBoTrabalhoAtual}
                    defaultChecked={isDefaultChecked}
                    disabled={estadoModal === 2}
                  >
                    Trabalho aqui atualmente
                  </Checkbox>
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col xs={24} sm={6}>
                <Form.Item label="Data Início"
                  name="dtInicio"
                  colon={false}
                  rules={[
                    {
                      required: exibirModalEx,
                      message: "Campo obrigatório",
                    },
                  ]}
                >
                  <DatePicker
                    format={"DD/MM/YYYY"}
                    style={{ width: "100%" }}
                    disabledDate={disabledDate}
                    placeholder="Selecionar Data"
                    disabled={estadoModal === 2}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={6}>
                <Form.Item label="Data Fim"
                  name="dtFim"
                  colon={false}
                  rules={[
                    {
                      validator: async (_, endDatetime) => {
                        let startDatetime = form.getFieldValue("dtInicio");
                        if (startDatetime) {
                          if (endDatetime <= startDatetime) {
                            return Promise.reject(
                              "Data de fim deve ser maior do que a data de início"
                            );
                          }
                        }
                      },
                    },

                  ]}
                >
                  <DatePicker
                    disabled={isDtFimDisabled || estadoModal === 2}
                    format={"DD/MM/YYYY"}
                    style={{ width: "100%" }}
                    placeholder="Selecionar Data"
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item label="Área"
                  labelCol={{ sm: { span: 24 } }}
                  labelAlign="left"
                  name="nomeAreaConhecimento"
                  colon={false}
                  rules={[
                    {
                      required: exibirModalEx,
                      message: "A área de conhecimento é obrigatória",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    filterOption
                    optionFilterProp='children'
                    placeholder='Área'
                    onChange={(_, index) => {
                      handlerArea(index);
                    }}
                    disabled={estadoModal === 2}
                  >
                    {areas?.map((e: IAreaConhecimento) => (
                      <Option key={e.idAreaConhecimento} value={e.idAreaConhecimento}>
                        {e.nmArea}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col xs={24} sm={24}>
                <Form.Item label="Cargo/Função"
                  labelCol={{ span: 24 }}
                  name="nomeOcupacaoPrincipal"
                  colon={false}
                  rules={[
                    {
                      required: exibirModalEx,
                      message: "O campo Cargo/Função é obrigatório",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    filterOption
                    optionFilterProp='children'
                    placeholder='Tipo'
                    onChange={(_, index) => {
                      handlerOcupacaoPrincipal(index);
                    }}
                    disabled={estadoModal === 2}
                  >
                    {ocupacoes?.map((e: IOcupacaoPrincipal) => (
                      <Option key={e.idOcupacao} value={e.idOcupacao}>
                        {e.nuCodigo + " - " + e.teTitulo}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col xs={24} sm={24}>
                <Form.Item label="Tipo de Vínculo"
                  labelCol={{ span: 24 }}
                  name="tipoVinculo"
                  colon={false}
                  rules={[
                    {
                      required: exibirModalEx,
                      message: "O campo tipo de vínculo é obrigatório",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    filterOption
                    optionFilterProp='children'
                    placeholder='Tipo Vínculo'
                    onChange={(_, index) => {
                      handlerTpVinculo(index);
                    }}
                    disabled={estadoModal === 2}
                  >
                    {lista_tipoVinculo?.map((e: any) => (
                      <Option key={e.enum} value={e.enum}>
                        {e.tipoVinculo}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col xs={24} sm={10}>
                <Form.Item label="Nível"
                  labelCol={{ span: 24 }}
                  name="nivel"
                  colon={false}
                  rules={[
                    {
                      required: exibirModalEx,
                      message: "O campo nível é obrigatório",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    filterOption
                    optionFilterProp='children'
                    placeholder='Nível'
                    onChange={(_, index) => {
                      handlerNivel(index);
                    }}
                    disabled={estadoModal === 2}
                  >
                    {lista_enumNivel?.map((e: any) => (
                      <Option key={e.enum} value={e.enum}>
                        {e.nivel}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} sm={8}>
                <Form.Item label='CNPJ'
                  labelCol={{ span: 24 }}
                  labelAlign="left"
                  name='nuCnpj'
                >
                  <Input
                    value={form.getFieldValue("nuCnpj")}
                    onChange={(e) => maskcnpjChange(e.target.value)}
                    maxLength={18}
                    onBlur={(e) => handleNuCnpjInputBlur(e.target.value)}
                    disabled={estadoModal === 2}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col xs={24} sm={24}>
                <Form.Item label='Razão Social'
                  labelCol={{ span: 24 }}
                  labelAlign="left"
                  name="nmRazaoSocial"
                >
                  <Input disabled={true} placeholder={"Razão Social"} />
                </Form.Item>
              </Col>
            </Row>

            {/* <Row>
              <Col xs={24} sm={24}>
                <Form.Item label='Nome Fantasia'
                  labelCol={{ span: 24 }}
                  labelAlign="left"
                  name="nmFantasia"
                >
                  <Input disabled={true} placeholder={"Nome Fantasia"} />
                </Form.Item>
              </Col>
            </Row> */}

            <Row>
              <Col xs={24} xl={24}>
                <Form.Item label='Descrição'
                  labelCol={{ span: 24 }}
                  name='teDescricao'
                >
                  <TextArea rows={4}
                    placeholder='Descrição'
                    maxLength={100}
                    disabled={estadoModal === 2}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Spin>
        </Modal>

      </>

      <Row style={{ display: exibirExperienciaCadastrada }}>
        <Col
          xs={24}
          xl={24}
          style={{ paddingLeft: 16, paddingRight: 16, marginBottom: 20 }}
        >
          <Table size="small" columns={columns} dataSource={experiencias} pagination={false} />
        </Col>
      </Row>

    </>
  )
};

export default PessoaFisicaExperiencia;